export default __webpack_public_path__ + "static/media/DeckTP.a128753c.png";